import React, { useEffect } from 'react';
import Cookies from 'js-cookie';
import thdCustomer from '@thd-olt-global/thd-customer';
import getSiteProduct from '../api/autobahn/getSiteProduct';
import sendSavedDesignEmail from '../api/designBuilder/sendSavedDesignEmail';
import config from '../helpers/config';

const SavedProductDesignLoader = ({
  saveProductDesignAlertDispatch,
  match,
}) => {
  useEffect(() => {
    saveProductDesignAlertDispatch();

    if (!window.THDCustomer) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = '//assets.homedepot-static.com/core/thd-customer/v4.12.1/thd-customer.js';
      document.getElementsByTagName('head')[0].appendChild(script);
    }
    // eslint-disable-next-line prefer-destructuring
    const designId = match.params.designId;

    // get email payload from cookie
    const cookie = Cookies.get('savedDesignEmailInfo');
    const savedDesignEmailInfo = cookie && JSON.parse(cookie);
    const routeTo = `${config.estimatebuilderBasePaths.chuck}${config.estimatebuilderLoadPath}/${designId}`;

    const email = thdCustomer && thdCustomer.email;
    if (email && savedDesignEmailInfo) {
      getSiteProduct(
        savedDesignEmailInfo.PartnerProductId,
        window.globalConfig.siteId,
      ).then((siteProductData) => {
        let productImageUrl = `${window.globalConfig.globalPaths.thdBaseUrl}${siteProductData.data.ImageUrl}?height=150`;
        productImageUrl = productImageUrl.replace(/\\/g, '/');

        sendSavedDesignEmail(
          email,
          designId,
          savedDesignEmailInfo.OrderTotal,
          savedDesignEmailInfo.Brand,
          productImageUrl,
          savedDesignEmailInfo.ProductName,
        ).then(() => {
          window.location = routeTo;
        }).catch((error) => {
          // eslint-disable-next-line no-console
          console.log('SavedProductDesignLoader -> error', error);
          window.location = routeTo;
        });
      });
    } else {
      window.location = routeTo;
    }
  }, []);

  const loader = () => (
    <div className="pre-loader relative w-100 flex items-center justify-center smaller-spinner">
      <span className="segment-spinner" />
    </div>
  );
  return loader();
};

export default SavedProductDesignLoader;
